import DataBinder from "../DataBinder.js"
import SwapPage from "../SwapPage.js"
export default class DefaultController {

  constructor(app) {
    this.app = app;
  }
  show(path, model) {
    model = this.getModel();

    //get page
    let pageId = path.split("/")[0];

    const dataBinder = new DataBinder();
    dataBinder.populate(pageId, model);

    const swapPage = new SwapPage();
    swapPage.swapPage(pageId);
  }
  getModel() {
    const app = this.app;
    const userdata = app.userdata;
    const config = app.config;
    const coins = userdata.coins;
    const isRewardedAdReady = app.isRewardedAdReady; 
    let showIAPPage = config.ShowIAPPage;


    const model = {
      coins,
      isRewardedAdReady,
      showIAPPage
    };

    return model;
  }
  showRewardedAd(){
    this.app.showRewardedAd();
  }
}